import { c as _c } from "react/compiler-runtime";
import { Heading, Stack } from 'ui';
import useJourneyData from '~/hooks/useJourneyData';
import useTripDisplayTitle from '~/hooks/useTripDisplayTitle';
import { SaveButton } from '../Common/SaveButton';
import ShareButton from '../Common/ShareButton/src/ShareButton';
import { MobileEditBlock } from '../MobileEditBlock/MobileEditBlock';
import JourneyCarbonFootprint from './JourneyCarbonFootprint';
export default function JourneyDescriptionMobile() {
  const $ = _c(16);
  const {
    uniqueId,
    isBookedTrip,
    details
  } = useJourneyData();
  const title = useTripDisplayTitle();
  let t0;
  if ($[0] !== title) {
    t0 = <Heading as="h1" variant="h4">{title}</Heading>;
    $[0] = title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = details?.startDate;
  const t2 = details?.endDate;
  let t3;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== uniqueId) {
    t3 = <SaveButton tripId={uniqueId} startDate={t1} endDate={t2} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = uniqueId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ShareButton />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <Stack horizontal={true} className="flex-wrap gap-4 pt-2 pb-3 whitespace-nowrap">{t3}{t4}</Stack>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isBookedTrip) {
    t6 = !isBookedTrip && <MobileEditBlock />;
    $[9] = isBookedTrip;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="text-left"><JourneyCarbonFootprint /></div>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t0 || $[13] !== t5 || $[14] !== t6) {
    t8 = <div className="px-4 mt-6 space-y-3 md:hidden">{t0}{t5}{t6}{t7}</div>;
    $[12] = t0;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}